// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill';
import Vue from "vue";
import App from "./App";
import router from "./router";
import axios from "axios";
import VueAxios from "vue-axios";
import VueCookies from "vue-cookies";
import VueSession from "vue-session";
import VueI18n from "vue-i18n";
import VueDraggable from "vue-draggable";
import en from "./lang/locale/en";
import ja from "./lang/locale/ja";
import de from "./lang/locale/de";
import VueAWN from "vue-awesome-notifications";
import store from "./store";
import Verte from "verte";
import "verte/dist/verte.css";
import { ImageUploader } from "vue-image-upload-resize";
import VueWait from "vue-wait";
import VeeValidate, { Validator } from "vee-validate";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
// import vSelect from 'vue-select';
import VTooltip from "v-tooltip";
import moment from "moment";
import BackToTop from "vue-backtotop";
import BootstrapVue from "bootstrap-vue";
import DatePicker from "vue-bootstrap-datetimepicker";
import VueProgressBar from 'vue-progressbar';
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
// import VuejsDialog from 'vuejs-dialog'
// import 'vuejs-dialog/dist/vuejs-dialog.min.css'
import Editor from "@tinymce/tinymce-vue";

import Vuebar from "vuebar";
import { VLazyImagePlugin } from "v-lazy-image";

import MultiSelect from "vue-multiselect";

import Meta from "vue-meta";
import vuetify from './plugins/vuetify';
Vue.prototype.moment = moment;

window.axios = require("axios");
const dictionary = {
  en: en,
  de: de
};

Validator.localize(dictionary);
Vue.use(VeeValidate, {
  useConstraintAttrs: false
});
Vue.use(VueI18n);
Vue.use(VueCookies);
Vue.use(VueAxios, axios);
Vue.use(VueDraggable);
Vue.use(VueWait);
Vue.use(VTooltip);
Vue.use(BackToTop);
Vue.use(BootstrapVue);
Vue.use(DatePicker);

Vue.use(Editor);
Vue.use(Vuebar);

Vue.use(VLazyImagePlugin);
Vue.use(Meta);
Vue.use(VueProgressBar, {
  color: 'rgb(113, 67, 155)',
  failedColor: 'red',
  thickness: '3px',
  autoFinish: false,
});
Vue.component("verte", Verte);
Vue.component("image-uploader", ImageUploader);
Vue.component("vue-dropzone", vue2Dropzone);
Vue.component("multi-select", MultiSelect);
// Vue.component('v-select', vSelect)

var sessionoptions = {
  persist: true
};
const options = {
  icons: { enabled: false },
  labels: {
    tip: "Tip",
    info: "Info",
    success: "Success",
    warning: "Attention",
    alert: "Error",
    async: "Loading",
    confirm: "Confirmation required"
  },
  modal: {
    okLabel: "Yes",
    cancelLabel: "No"
  },
  position: "top-right"
};
const locale = "en";
const messages = {
  de: de,
  en: en,
  ja: ja
};
// const messages = {
//   en: {
//     message: {
//       hello: 'hello world'
//     }
//   },
//   de: {
//     message: {
//       hello: 'こんにちは、世界'
//     }
//   }
// }
const i18n = new VueI18n({
  locale,
  messages
});

export const EventBus = new Vue();
// export const questionTypeBus = new Vue()
export default i18n;

Vue.config.productionTip = false;
Vue.use(VueAWN, options);
Vue.use(VueSession, sessionoptions);
window.Vue = Vue;
// Vue.use(VuejsDialog)
var app = new Vue({
  // eslint-disable-line no-new
  render: h => h(App),
  router,
  i18n,
  store,
  vuetify,
  wait: new VueWait({
    // Defaults values are following:
    useVuex: false, // Uses Vuex to manage wait state
    vuexModuleName: "LeftSidebarCreate", // Vuex module name

    registerComponent: true, // Registers `v-wait` component
    componentName: "v-wait", // <v-wait> component name, you can set `my-loader` etc.

    registerDirective: true, // Registers `v-wait` directive
    directiveName: "wait" // <span v-wait /> directive name, you can set `my-loader` etc.
  }),
  components: {
    App,
    Verte,
    ImageUploader,
    vueDropzone: vue2Dropzone,
    editor: Editor
  },
  template: "<App/>"
}).$mount("#app");



// WEBPACK FOOTER //
// ./src/main.js